import { render, staticRenderFns } from "./UiTextbox.vue?vue&type=template&id=1c1e2049&scoped=true&"
import script from "./UiTextbox.vue?vue&type=script&lang=js&"
export * from "./UiTextbox.vue?vue&type=script&lang=js&"
import style0 from "./UiTextbox.vue?vue&type=style&index=0&id=1c1e2049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e2049",
  null
  
)

export default component.exports